"use client";

import createIcon from './util/createIcon';
export default createIcon('M18 12C18 7.5 16.08 3.26 12 2A10 10 0 0 0 12 22C16.08 20.74 18 16.5 18 12Z', 'MoonWaningGibbous');